import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, {
      modelValue: _ctx.menu,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menu) = $event)),
      "close-on-content-click": false,
      transition: "scale-transition",
      location: "bottom",
      "min-width": "auto"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_text_field, _mergeProps({
          "model-value": _ctx.displayValue,
          label: _ctx.label,
          "prepend-inner-icon": "mdi-calendar",
          readonly: ""
        }, props, {
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          color: "primary",
          clearable: _ctx.clearable,
          "onClick:clear": _ctx.clearValue
        }), null, 16, ["model-value", "label", "clearable", "onClick:clear"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_locale_provider, { locale: "en" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              elevation: "4",
              class: "d-inline-block rounded-lg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_date_picker, {
                  "model-value": _ctx.pickerAnchor,
                  "view-mode": "months",
                  "hide-header": "",
                  color: "primary",
                  elevation: "0",
                  "onUpdate:year": _ctx.onYearUpdate,
                  "onUpdate:month": _ctx.onMonthUpdate
                }, null, 8, ["model-value", "onUpdate:year", "onUpdate:month"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}